import React, { Component } from "react";
import EventIntro from "../Event/EventIntro";
import EventIntroCondensed from "../Event/EventIntroCondensed";
// import LiveHelp from '../Lives/LiveHelp';
// import AvailableEvents from 'components/Event/AvailableEvents';
import ScrollToTopOnMount from "components/UI/ScrollToTopOnMount";
import EventSelector from "components/Event/EventSelector";
import HomeHelp from "components/Home/HomeHelp";
import i18n from "helpers/i18n";
import EventSubscriptionRecapSingle from "components/Event/EventSubscriptionRecapSingle";
import EventSubscription from "components/Event/EventSubscription";
import BlockRatio from "components/BlockRatio";
import BlockTitle from "components/UI/BlockTitle";
import BlockButton from "components/UI/BlockButton";
import Dialog from "components/UI/Dialog/Dialog";
import Immutable from "immutable";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
// import Popper from "@material-ui/core/Popper";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import Avatar from "@material-ui/core/Avatar";
import clsx from "clsx";
import { withRouter } from "react-router-dom";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import StepIcon from "@material-ui/core/StepIcon";
import StepConnector from "@material-ui/core/StepIcon";
import WarningIcon from "@material-ui/icons/Warning";
import EventSubscriptionVisitor from "components/Event/EventSubscriptionVisitor";
import EventSubscriptionFor from "components/Event/EventSubscriptionFor";
import { primaryColor, secondaryColor } from "helpers/colors";
const styles = (theme) => {
  // console.log({theme})
  return {
    root: {
      maxWidth: "1280px",
      margin: "0 auto",
    },
    mainTitle: {
      fontWeight: "bold",
    },
    stepIcon: {
      margin: "0 auto",
    },
    bg: {
      // background: 'linear-gradient(180deg, rgba(241,243,244,0.42) 0%, rgba(223,227,229,0.42) 100%)',
      // backgroundColor: '#F4F5F6'
    },
    titleBig: {
      fontSize: "2rem",
    },
    headerImage: {
      width: "100%",
      height: "100%",
      // minHeight: 300,
      maxHeight: 300,
    },
    headerImageWrapper: {
      padding: theme.spacing(0),
      [theme.breakpoints.down("sm")]: {
        padding: theme.spacing(2),
      },
    },
    bgAlt: {
      position: "relative",
      "&:after": {
        content: '" "',
        position: "absolute",
        bottom: 0,
        left: 0,
        width: "100%",
        height: "calc(50% + 7px)",
        backgroundColor: "#F4F5F6",
        "& .MuiStepLabel-labelContainer": {
          display: "none",
        },
      },
    },
    inline: {
      display: "inline-block",
      verticalAlign: "middle",
    },
    inlineIcon: {
      display: "inline-block",
      verticalAlign: "middle",
      marginTop: "-3px",
      marginRight: theme.spacing(1),
    },
    emphasis: {
      color: theme.palette.secondary.main,
    },
    bigButton: {
      fontWeight: "bold",
      borderRadius: "0",
      fontSize: "16px",
      letterSpacing: "1px",
      padding: "15px 30px",
      display: "flex",
      margin: "0 auto",
    },
    instructions: {
      fontSize: "0.9rem",
    },
    bgSpacerBottom: {
      height: 35,
      marginTop: theme.spacing(8),
      backgroundRepeat: "no-repeat",
      backgroundPosition: "50% 50%",
      backgroundSize: "cover",
      backgroundImage: `url(${require("assets/images/" +
        process.env.REACT_APP_SITE +
        "/halfcircle.jpg")})`,
      [theme.breakpoints.down("xs")]: {
        height: 10,
      },
    },
    eventSelectorWrapper: {
      backgroundColor: primaryColor,
      color: "#fff",
      padding: theme.spacing(2),
      [theme.breakpoints.down("xs")]: {
        padding: theme.spacing(1),
      },
      "& .MuiButton-root": {
        backgroundColor: secondaryColor,
      },
    },
    eventSelectorTitle: {
      color: "#fff",
    },
    h2: {
      fontSize: "2.2rem",
      lineHeight: "2.8rem",
      [theme.breakpoints.down("sm")]: {
        fontSize: "1.6rem",
        lineHeight: "2rem",
        padding: "0 10px",
      },
    },
    h4: {
      fontSize: "1.3rem",
      lineHeight: "1.8rem",
      "& a": {
        color: theme.palette.primary.main,
        fontWeight: "bold",
      },
      [theme.breakpoints.down("sm")]: {
        fontSize: "1.1rem",
        lineHeight: "1.5rem",
        padding: "0 10px",
      },
    },
  };
};
const ColorlibConnector = withStyles({
  // active: {
  //   '& $line': {
  //     backgroundImage:
  //       'linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)',
  //   },
  // },
  // completed: {
  //   '& $line': {
  //     backgroundImage:
  //       'linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)',
  //   },
  // },
  line: {
    height: 0,
    border: 0,
    // backgroundColor: '#eaeaf0',
    borderRadius: 1,
  },
})(StepConnector);
const useColorlibStepIconStyles = makeStyles((theme) => {
  return {
    root: {
      backgroundColor: "#fff",
      zIndex: 1,
      border: "2px " + theme.palette.primary.main + " solid",
      color: theme.palette.primary.main,
      fontSize: "24px",
      width: 45,
      height: 45,
      fontWeight: "bold",
      opacity: 1,
      display: "flex",
      borderRadius: "50%",
      justifyContent: "center",
      alignItems: "center",
      position: "relative",
      "&:after": {
        position: "absolute",
        top: "-10%",
        left: "-10%",
        backgroundColor: "#fff",
        border: "2px #fff solid",
        width: "120%",
        height: "120%",
        content: '" "',
        borderRadius: "50%",
        opacity: 0.6,
      },
      "& .MuiStepper-root": {
        padding: 0,
      },
      //       '& .MuiStepLabel-labelContainer': {
      // display: 'none'
      // }
    },
    active: {
      "&:after": {
        display: "none",
      },
      // opacity: 1
    },
    stepper: {
      padding: 0,
    },
    inline: {
      display: "inline-block",
      verticalAlign: "middle",
    },
    // completed: {
    //   backgroundImage:
    //     'linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)',
    // },
  };
});

function ColorlibStepIcon(props) {
  const classes = useColorlibStepIconStyles();
  const { active, completed } = props;
  const icons = {
    1: "1",
    2: "2",
    3: "3",
  };
  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
        [classes.completed]: completed,
      })}
    >
      {icons[String(props.icon)]}
    </div>
  );
}
class HomeSubscribe extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeStep: 0,
      // activeStep: 2,
      isLoggingIn: false,
      // $$selectedEvents: Immutable.fromJS([{id: "99b7b4fdee89c1c0a41cce9dbb41a2c2"}])
      $$selectedEvents: Immutable.fromJS([]),
    };
  }
  _goto = (url) => {
    const { history } = this.props;
    history.push(url);
  };
  _onSelectionComplete = ($$selectedEvents) => {
    // console.log('$$selectedEvents', $$selectedEvents)
    this.setState({
      $$selectedEvents: $$selectedEvents,
      activeStep: 1,
    });
    // console.log($$selectedEvents.toJS())
    // this.setState({$$selectedEvents: $$selectedEvents, activeStep: 2})
  };
  _onSelectionReset = () => {
    this.setState({
      $$selectedEvents: Immutable.fromJS([]),
      activeStep: 0,
    });
  };
  _onSubscriptionComplete = (r) => {
    // console.log('got', {
    // r
    // })
    this.setState({
      activeStep: 2,
      accountJob: r && r.accountJob ? r.accountJob : false,
      isNewMember: r && r.isNewMember ? r.isNewMember : false,
    });
  };
  _onSubscriptionError = (reason, object) => {
    this.setState({
      activeStep: 99,
    });
  };
  _onComplete = () => {
    const { onSubscriptionComplete } = this.props;
    onSubscriptionComplete();
    this._goto("/");
    // this.setState({activeStep: 0})
  };
  render() {
    const {
      $$availableEvents,
      $$subscriptions,
      userRole,
      $$user,
      onSubscriptionComplete,
      classes,
      themeId,
      $$pastEvents,
      directRegistration,
    } = this.props;
    const {
      activeStep,
      $$selectedEvents,
      isLoggingIn,
      accountJob,
      isNewMember,
    } = this.state;
    // console.log({
    //   accountJob,
    //   isNewMember
    // })
    const $$steps = Immutable.fromJS([
      "Choix des dates",
      "Identification",
      "Récapitulatif",
    ]);
    // const $$subscriptions = userRole !== undefined && $$data !== undefined && $$data.get('myfutureevents') !== undefined
    // ? $$data.get('myfutureevents').map(e => e.get('id'))
    // : Immutable.Map();
    // console.log({userRole, isLoggingIn})
    const isNeoNat = process.env.REACT_APP_SITE === "neonat";
    const isTransplant = process.env.REACT_APP_SITE === "transplant";

    // console.log({isNewMember})
    return (
      <div className={classes.root}>
        {/*<Box align="center" mt={4} mb={8} px={4}>
        <Typography variant={'h2'} gutterBottom={true} className={classes.mainTitle}>
        <Choose>
        <When condition={$$availableEvents === undefined || $$availableEvents.size < 1}>
        Les inscriptions sont actuellement closes
        </When>
        <When condition={$$availableEvents !== undefined && $$availableEvents.size > 0 && (userRole === 'admin' || userRole === 'staff')}>
        Choisissez la session à ajouter à un participant
        </When>
        <Otherwise>
        3 étapes pour vous inscrire
        </Otherwise>
        </Choose>
        </Typography>

      </Box>*/}

        <Box className={classes.bg} mt={-4}>
          <If
            condition={
              $$availableEvents !== undefined && $$availableEvents.size > 0
            }
          >
            {/*<Box className={classes.bgAlt}>
            <Stepper activeStep={activeStep} alternativeLabel={true} classes={{
            root: classes.stepper
            }}>
            {
            $$steps.map((label) => (<Step key={label}>
            <StepLabel StepIconComponent={ColorlibStepIcon}></StepLabel>
            </Step>))
            }
            </Stepper>
          </Box>*/}
            <Box maxWidth={1280} px={6} mx={"auto"} mt={2}>
              <EventSubscriptionRecapSingle
                $$events={
                  activeStep === 1 || activeStep === 2
                    ? $$selectedEvents
                    : $$availableEvents
                }
                onSelectionReset={this._onSelectionReset}
                showDates={
                  (activeStep === 1 && userRole === "member" && !isLoggingIn) ||
                  activeStep === 2
                }
              />
            </Box>
            <Choose>
              <When condition={activeStep === 0}>
                <ScrollToTopOnMount />

                {isNeoNat ? (
                  <Box className={classes.bgSpacerBottom}></Box>
                ) : null}

                {isTransplant ? (
                  <Box
                    className={classes.bgSpacerBottom}
                    style={{ height: 76 }}
                  ></Box>
                ) : null}

                <Box
                  className={clsx({
                    [classes.eventSelectorWrapper]: isNeoNat || isTransplant,
                  })}
                >
                  <Box align="center" mb={4}>
                    <Typography
                      variant="h5"
                      gutterBottom={true}
                      className={clsx({
                        [classes.eventSelectorTitle]: isNeoNat || isTransplant,
                      })}
                    >
                      {i18n.get("selectAnEvent", { prettyfy: false })}
                      <em>{$$availableEvents.get(0).get("eventName")}</em>
                    </Typography>
                  </Box>

                  <EventSelector
                    $$data={$$availableEvents}
                    $$subscriptions={$$subscriptions}
                    userRole={userRole}
                    onSelectionComplete={this._onSelectionComplete}
                    $$user={$$user}
                    $$pastEvents={$$pastEvents}
                    themeId={themeId}
                  />

                {/*  <If condition={process.env.REACT_APP_SITE === 'pneumo_medevent'}>
                <Box align="center">
                  <img src={require('assets/images/'+process.env.REACT_APP_SITE+'/sponsor-1.png')}/>
                  <img src={require('assets/images/'+process.env.REACT_APP_SITE+'/sponsor-2.png')}/>
                </Box>
              </If>*/}
                </Box>

                <If condition={i18n.has("subscriptionWarningLabel")}>
                  <Box
                    align="center"
                    mb={2}
                    bgcolor="common.white"
                    br="30px"
                    width="90%"
                    ml="5%"
                    py={2}
                    px={4}
                  >
                    <Typography
                      variant="h6"
                      gutterBottom={true}
                      color="primary"
                    >
                      <WarningIcon className={classes.inlineIcon} />
                      <strong className={classes.inline}>
                        {i18n.get("subscriptionWarningLabel", {
                          pretty: true,
                        })}
                      </strong>
                      &nbsp;
                      <span className={classes.inline}>
                        {i18n.get("subscriptionWarningParagraph1")}
                      </span>
                      <br />
                      <span className={classes.inline}>
                        {i18n.get("subscriptionWarningParagraph2")}
                      </span>
                    </Typography>
                  </Box>
                  <Box align="center" pb={6} br="30px" width="100%" px={4}>
                    {i18n.get("subscriptionWarningDetails")}
                  </Box>
                </If>
              </When>

              <When condition={activeStep === 1}>
                <ScrollToTopOnMount />
                <If
                  condition={
                    userRole === undefined ||
                    userRole === "visitor" ||
                    isLoggingIn
                  }
                >
                  <Box
                    align="center"
                    maxwidth={1024}
                    mb={4}
                    color="primary.black"
                    px={3}
                  >
                    <EventSubscriptionVisitor
                      $$events={$$selectedEvents}
                      userRole={userRole}
                      onSubscriptionComplete={this._onSubscriptionComplete}
                    />
                  </Box>
                </If>
                <If
                  condition={
                    (userRole === "member" || userRole === "staff") &&
                    !isLoggingIn
                  }
                >
                  <Box align="center" mb={4} color="primary.black">
                    <Typography variant="h5" gutterBottom={true}>
                      {i18n.get("homeSubsValidateHelp", {
                        prettyfy: false,
                      })}
                    </Typography>
                  </Box>
                  <EventSubscription
                    $$events={$$selectedEvents}
                    userRole={userRole}
                    showRecap={false}
                    $$user={$$user}
                    onSubscriptionComplete={this._onSubscriptionComplete}
                    onSubscriptionError={this._onSubscriptionError}
                    onSelectionReset={this._onSelectionReset}
                    themeId={themeId}
                  />
                </If>

                <If condition={userRole === "admin" && !isLoggingIn}>
                  <EventSubscriptionFor
                    $$events={$$selectedEvents}
                    $$user={$$user}
                    userRole={userRole}
                    onSelectionReset={this._onSelectionReset}
                    themeId={themeId}
                  />
                </If>
              </When>
              <When condition={activeStep === 2}>
                <ScrollToTopOnMount />
                <Dialog open={true}>
                  <Box pb={4}>
                    <Box align="center" mb={4} color="primary.black">

                      <If condition={i18n.has("registrationSuccessTitle") && isNewMember === true}>
                        <Typography
                          variant={"h2"}
                          classes={{ root: classes.h2 }}
                          gutterBottom
                        >
                          {i18n.get("registrationSuccessTitle", {
                            pretty: true,
                            element: "div",
                          })}
                        </Typography>
                      </If>
                      <If condition={i18n.has("registrationModificationSuccessTitle") && isNewMember !== true}>
                        <Typography
                          variant={"h2"}
                          classes={{ root: classes.h2 }}
                          gutterBottom
                        >
                          {i18n.get("registrationModificationSuccessTitle", {
                            pretty: true,
                            element: "div",
                          })}
                        </Typography>
                      </If>
                    </Box>

                    <If condition={isNewMember === true && accountJob === "x1"}>
                      <Typography
                        variant={"h4"}
                        className={classes.h4}
                        gutterBottom
                      >
                        {i18n.get("registrationLogStudents", { pretty: true })}{" "}
                      </Typography>
                    </If>
                    <If condition={isNewMember === true && accountJob === "x2"}>
                      <Typography
                        variant={"h4"}
                        className={classes.h4}
                        gutterBottom
                      >
                        {i18n.get("registrationLogMdNoRpps", { pretty: true })}{" "}
                      </Typography>
                    </If>
                    <If
                      condition={
                        isNewMember === true &&
                        accountJob !== "x1" &&
                        accountJob !== "x2"
                      }
                    >
                      <Typography
                        variant={"h4"}
                        className={classes.h4}
                        gutterBottom
                      >
                        {i18n.get("registrationLogSuccess", { pretty: true })}
                      </Typography>
                    </If>

                    <If
                      condition={
                        isNewMember !== true &&
                        i18n.has("subscriptionSelfSuccessText")
                      }
                    >
                      <Typography
                        variant={"h5"}
                        classes={{
                          root: classes.h5,
                        }}
                        gutterBottom={true}
                      >
                        {i18n.get("subscriptionSelfSuccessText")}
                      </Typography>
                    </If>
                    <If condition={directRegistration === true}>
                      <Typography
                        variant={"h5"}
                        classes={{
                          root: classes.h5,
                        }}
                        gutterBottom={true}
                        align="center"
                      >
                        A bientôt !
                      </Typography>
                    </If>
                    <If condition={directRegistration !== true}>
                    <Box mt={4} align="middle">
                      <Button
                        size="large"
                        className={classes.bigButton}
                        onClick={this._onComplete}
                      >
                        Terminer
                      </Button>
                    </Box>
                    </If>
                  </Box>
                </Dialog>
              </When>
              <When condition={activeStep === 99}>
                <ScrollToTopOnMount />
                {isNeoNat ? (
                  <Box className={classes.bgSpacerBottom}></Box>
                ) : null}
                {isTransplant ? (
                  <Box className={classes.bgSpacerBottom}></Box>
                ) : null}

                <Box
                  className={clsx({
                    [classes.eventSelectorWrapper]: isNeoNat || isTransplant,
                  })}
                >
                  <Box pb={10}>
                    <Box align="center" mb={4} px={2}>
                      <Typography
                        variant={"h2"}
                        classes={{
                          root: classes.h2,
                        }}
                        style={
                          isNeoNat || isTransplant ? { color: "#fff" } : {}
                        }
                        gutterBottom={true}
                      >
                        {i18n.get("subscriptionSelfErrorTitle", {
                          prettyfy: true,
                        })}
                      </Typography>
                    </Box>

                    <Box align="center" mb={4} px={2}>
                      <If condition={i18n.has("subscriptionSelfErrorText")}>
                        <Typography
                          variant={"h5"}
                          classes={{
                            root: classes.h5,
                          }}
                          style={
                            isNeoNat || isTransplant ? { color: "#fff" } : {}
                          }
                          gutterBottom={true}
                        >
                          {i18n.get("subscriptionSelfErrorText")}
                        </Typography>
                      </If>
                    </Box>
                    <Box align="middle">
                      <Button
                        size="large"
                        onClick={this._onComplete}
                        className={classes.bigButton}
                      >
                        Terminer
                      </Button>
                    </Box>
                  </Box>
                </Box>
              </When>
              <Otherwise></Otherwise>
            </Choose>
          </If>
          <If
            condition={
              $$availableEvents === undefined || $$availableEvents.size < 1
            }
          >
            <Box align="middle" py={6}>
              <WarningIcon className={classes.inlineIcon} />
              Nous sommes désolé mais il n'y a actuellement pas d'émission
              disponible
            </Box>
          </If>
        </Box>
      </div>
    );
  }
}
export default withRouter(withStyles(styles)(HomeSubscribe));



// WEBPACK FOOTER //
// ./src/components/Home/HomeSubscribe.jsx